<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <v-list-item class="py-3">
          <v-list-item-content v-if="this.$store.state.user.user">
            <v-list-item-title class="py-1 text-center">
              <b>{{ this.$store.state.user.user.full_name }}</b>
            </v-list-item-title>
            <v-list-item-subtitle class="py-1 subtitle-1">
              <v-chip color="secondary" small>
                {{ getRoleUser(this.$store.state.user.user.role) }}
              </v-chip>
            </v-list-item-subtitle>
            <v-list-item-subtitle
              class="py-1 subtitle-1"
              v-if="this.$store.state.user.user.employee"
            >
              <v-chip
                :color="
                  getEmployeeStatuColor(
                    this.$store.state.user.user.employee.status
                  )
                "
                dark
                small
              >
                {{
                  getEmployeeStatus(this.$store.state.user.user.employee.status)
                }}
              </v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          v-for="item in validItemsMenu"
          :key="item.text"
          :to="item.to"
          active-class="secondary white--text"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-left">{{
              item.text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click="logout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-left">Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left v-if="this.$store.state.user.user">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title> Live </v-toolbar-title>

      <v-spacer></v-spacer>

      <div v-if="this.$store.state.user.user.employee">
        <v-badge color="primary" overlap :content="totalNotes">
          <v-btn icon small href="/profile#notes">
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </v-badge>
      </div>
    </v-app-bar>

    <v-main>
      <!-- Load Route -->
      <router-view />
    </v-main>

    <v-footer app absolute class="font-weight-medium">
      <v-col cols="12" class="text-center pa-0"
        >&copy; {{ new Date().getFullYear() }}</v-col
      >
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    drawer: null,
    drawerItems: [
      {
        text: "Inicio",
        to: "/",
        icon: "mdi-home",
        roles: ["*"],
      },
      {
        text: "Colaboradores",
        to: "/employees",
        icon: "mdi-account-group",
        roles: ["ADMINISTRATOR"],
      },
      {
        text: "Contratos",
        to: "/contracts",
        icon: "mdi-file-document-multiple-outline",
        roles: ["ADMINISTRATOR", "EMPLOYEE"],
      },
      {
        text: "Informes",
        to: "/reports",
        icon: "mdi-file-chart",
        roles: ["ADMINISTRATOR", "EMPLOYEE", "REVIEWER"],
      },
      {
        text: "Cuentas de cobro",
        to: "/bills",
        icon: "mdi-text-box-outline",
        roles: ["ADMINISTRATOR", "EMPLOYEE"],
      },
      {
        text: "Cargos",
        to: "/charges",
        icon: "mdi-card-account-details",
        roles: ["ADMINISTRATOR"],
      },
      {
        text: "Perfil",
        to: "/profile",
        icon: "mdi-account",
        roles: ["EMPLOYEE"],
      },
      {
        text: "Usuarios",
        to: "/users",
        icon: "mdi-account-multiple-outline",
        roles: ["ADMINISTRATOR"],
      },{
        text: "Areas",
        to: "/areas",
        icon: "mdi-account-group-outline",
        roles: ["ADMINISTRATOR"],
      },
      {
        text: "Configuración",
        to: "/configurations",
        icon: "mdi-tools",
        roles: ["ADMINISTRATOR"],
      },
    ],
  }),
  computed: {
    ...mapGetters([
      "getRoleUser",
      "getEmployeeStatus",
      "getEmployeeStatuColor",
    ]),
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
    validItemsMenu() {
      var validItems = [];
      this.drawerItems.forEach((item) => {
        if (this.validateRole(item.roles, item.text)) {
          validItems.push(item);
        }
      });
      return validItems;
    },
    totalNotes() {
      return this.$store.state.user.user.notes.length == 0
        ? "0"
        : this.$store.state.user.user.notes.length;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    validateRole(roles, text) {
      if (roles.indexOf("*") >= 0) {
        return true;
      }

      if (this.role == "EMPLOYEE") {
        if (text == "Perfil") {
          return true;
        }

        if (
          this.$store.state.user.user.employee.status == "ACTIVE" &&
          roles.indexOf(this.role) >= 0
        ) {
          return true;
        }

        return false;
      }

      if (roles.indexOf(this.role) >= 0) {
        return true;
      }

      return false;
    },
  },
};
</script>
<style>
.v-main__wrap {
  padding: 20px;
}
</style>
